import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M31.967 18H.029a38 38 0 0 1-.026-2.017c-.008-.64.001-1.304.03-1.983h31.938q.04 1.034.026 2.016.013.964-.03 1.984",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M8.788 10.368 6.674 11.84l.746-2.465-2.052-1.556 2.574-.052.846-2.433.845 2.433 2.575.052-2.052 1.556.746 2.465zM4.667 5.61l-1.237.86.436-1.44-1.2-.91 1.506-.03.495-1.423.494 1.422 1.506.03-1.2.91.436 1.442z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCuw = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCuw_default = SvgFlagCuw;

export { FlagCuw_default as default };
